module.exports = __webpack_public_path__ + "img/Bodice-Back-Ka-La.bab1f090.png";